import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import { RatingsSize, RatingsInput } from 'wix-ui-tpa/cssVars';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { classes } from './rating-input-field-wut.st.css';
import Fieldset from '../fieldset';
import { useTranslation } from '../../contexts/translation-context';
import { useFocusFieldEvent } from '../../contexts/events-context';
export const RatingInputFieldWUT = _ref => {
  let {
    id,
    target,
    label,
    hideLabel = false,
    required = false,
    description,
    value,
    onChange,
    onFocus,
    onBlur,
    error,
    disabled = false,
    hasError = false,
    errorMessage,
    additionalInfo,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    defaultValue
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const inputRef = useRef(null);
  const handleChange = useCallback(_value => {
    onChange(_value);
  }, [onChange]);
  const getReactionLabel = useCallback(_value => t('rating-input.a11y.reaction-label', {
    count: _value
  }), [t]);
  useFocusFieldEvent(() => {
    var _inputRef$current;
    (_inputRef$current = inputRef.current) == null || _inputRef$current.focus({
      preventScroll: true
    });
  }, id);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(Fieldset, {
      id: inputId,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy,
      onFocus: onFocus,
      onBlur: onBlur,
      required: required
    }, /*#__PURE__*/React.createElement(RatingsInput, {
      value: value || defaultValue || 0,
      onSelect: handleChange,
      size: RatingsSize.Large,
      disabled: disabled,
      className: classNames(classes.rating, {
        [classes.error]: hasError
      }),
      getReactionLabel: getReactionLabel,
      showReactionLabel: false,
      ref: inputRef
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }), additionalInfo)
  });
};
//# sourceMappingURL=rating-input-field-wut.js.map